import _flatten from 'lodash/flatten'

const getAjax = (url) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()

    xhr.onload = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          resolve(
            xhr.responseText && {
              data: JSON.parse(xhr.responseText),
            }
          )
        } else {
          reject(xhr.responseText)
        }
      }
    }

    xhr.onerror = () => {
      reject(xhr.status)
    }

    xhr.open('GET', url, true)
    xhr.send()
  })
}

const module = {
  registered: false,
  namespaced: true,
  state: () => ({
    criteria: {},
    magazineFilter: {},
    magazineList: [],
    magazine: {},
    breadcrumbs: [],
  }),
  getters: {
    magazineFilter: (state) => state.magazineFilter,
    magazineList: (state) => state.magazineList,
    criteria: (state) => state.criteria,
    magazine: (state) => state.magazine,
    breadcrumbs: (state) => state.breadcrumbs,
  },
  actions: {
    async getListFilter({ commit }) {
      try {
        const { data } = await this.$http.get('/contents/v1/magazine/list-filter')
        commit('setMagazineFilter', data)
      } catch (err) {
        console.log(err)
      }
    },
    async getMagazineList({ commit }, params) {
      try {
        const { data } = await this.$http.post(`/contents/v1/magazine/list`, params)
        commit('setMagazineList', { data, reset: params.paging.no == 1 })
      } catch (err) {
        console.log(err)
      }
    },
    async getMagazine({ commit }, key) {
      try {
        const { data } = await this.$http.get(`/contents/v1/magazine/detail/${key}`)

        const getMediaInfo = (entry) => {
          return new Promise(async (resolve, reject) => {
            const { media } = entry
            const defaultVal = {
              width: 800,
              height: 600,
            }
            if (media && media.type === 'VIDEO' && media.url) {
              let matched = media.url.match(
                /(http:|https:|)\/\/(player.|www.|m.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
              )
              let id = RegExp.$6

              if (RegExp.$3.indexOf('youtu') > -1) {
                let url = `https://www.youtube.com/watch?v=${id}`
                let response
                if (process.env.VUE_ENV === 'server') {
                  response = await this.$http
                    .get(
                      `https://www.youtube.com/oembed?url=${encodeURIComponent(url)}&format=json`
                    )
                    .catch((err) => {
                      return { data: defaultVal }
                    })
                } else {
                  response = await getAjax(
                    `https://noembed.com/embed?url=${encodeURIComponent(url)}`
                  ).catch((err) => {
                    console.log(`[getAjax]`, err)
                    return { data: defaultVal }
                  })
                }

                Object.assign(
                  media,
                  defaultVal,
                  response &&
                    response.data && {
                      url: `https://www.youtube.com/embed/${id}`,
                      width: response.data.width || 800,
                      height: response.data.height || 600,
                    }
                )
              } else if (RegExp.$3.indexOf('vimeo') > -1) {
                let url = `https://vimeo.com/${id}`
                let response
                if (process.env.VUE_ENV === 'server') {
                  response = await this.$http
                    .get(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`)
                    .catch((err) => {
                      return { data: defaultVal }
                    })
                } else {
                  response = await getAjax(
                    `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`
                  ).catch((err) => {
                    console.log(`[getAjax]`, err)
                    return { data: defaultVal }
                  })
                }

                Object.assign(
                  media,
                  defaultVal,
                  response &&
                    response.data && {
                      url: `https://player.vimeo.com/video/${id}`,
                      width: response.data.width || 800,
                      height: response.data.height || 600,
                    }
                )
              } else {
                Object.assign(media, defaultVal)
              }
            }
            resolve()
          })
        }

        return Promise.all(
          data &&
            _flatten(
              data.contents.map((content) => {
                return content.map((entry) => {
                  return getMediaInfo(entry)
                })
              })
            )
        ).then((val) => {
          commit('setMagazine', data)
        })
      } catch (e) {
        console.log(e)
      }
    },
  },
  mutations: {
    setMagazineFilter(state, filter) {
      state.magazineFilter = filter
    },
    setMagazineList(state, { data, reset }) {
      state.magazineList = reset ? data.list : [...state.magazineList, ...data.list]
      state.criteria = data.criteria
      state.breadcrumbs = data.breadcrumbs
    },
    setMagazine(state, magazine) {
      state.magazine = magazine
    },
  },
}

export default module
